import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/css/tailwind.css";
import Swal from 'sweetalert2'

import SmartTable from 'vuejs-smart-table'
// FONTAWESOME ICONS
import "@fortawesome/fontawesome-free/css/all.css";

Vue.prototype.$swal = Swal
Vue.config.productionTip = false;

Vue.use(SmartTable)

Swal.mixin({
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  buttonsStyling: true
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
